import React, { createContext, useEffect, useRef, useState } from "react"
import { io } from "socket.io-client"

const SocketContext = createContext()

const SocketProvider = ({ children }) => {
    const [socket, setSocket] = useState({
        connected: false,
        on: () => {},
        emit: () => {},
        onAny: () => {},
        off: () => {},
    })
    const [isConnected, setIsConnected] = useState(false)
    const socketRef = useRef(null)

    useEffect(() => {
        console.log("🚀 Iniciando conexão socket...")

        const userId = localStorage.getItem("userId")
        const companyId = localStorage.getItem("companyId")

        if (!userId || !companyId || !process.env.REACT_APP_BACKEND_URL) {
            console.error("❌ Dados necessários não encontrados")
            return
        }

        // Limpar socket anterior
        if (socketRef.current) {
            socketRef.current.removeAllListeners()
            socketRef.current.disconnect()
        }

        // Criar novo socket
        const newSocket = io(process.env.REACT_APP_BACKEND_URL, {
            transports: ["polling", "websocket"],
            query: { companyId, userId },
            reconnection: true,
            reconnectionAttempts: 5,
            reconnectionDelay: 3000,
            timeout: 20000,
        })

        console.log("🔌 Socket criado:", newSocket)

        // Eventos básicos
        newSocket.on("connect", () => {
            console.log("🟢 Conectado! ID:", newSocket.id)
            setIsConnected(true)
        })

        newSocket.on("disconnect", (reason) => {
            console.log("🔴 Desconectado:", reason)
            setIsConnected(false)
        })

        newSocket.on("connect_error", (error) => {
            console.error("❌ Erro de conexão:", error.message)
            setIsConnected(false)
        })

        // Salvar referências
        socketRef.current = newSocket
        setSocket(newSocket)

        // Verificar se conectou
        setTimeout(() => {
            if (newSocket.connected) {
                console.log("✅ Socket conectado com sucesso!")
            } else {
                console.log("⚠️ Socket não conectou ainda...")
                console.log("📊 Estado atual:", {
                    connected: newSocket.connected,
                    id: newSocket.id,
                    transport: newSocket.io?.engine?.transport?.name,
                })
            }
        }, 3000)

        // Cleanup
        return () => {
            console.log("🧹 Limpando socket...")
            newSocket.removeAllListeners()
            newSocket.disconnect()
        }
    }, [])

    const contextValue = {
        socket,
        isConnected,
        reconnect: () => {
            if (socketRef.current) {
                console.log("🔄 Reconectando...")
                socketRef.current.disconnect()
                socketRef.current.connect()
            }
        },
    }

    return (
        <SocketContext.Provider value={contextValue}>
            {children}
        </SocketContext.Provider>
    )
}

// Hook personalizado
const useSocket = () => {
    const context = React.useContext(SocketContext)
    if (!context) {
        throw new Error("useSocket deve ser usado dentro de um SocketProvider")
    }
    return context
}

export { SocketContext, SocketProvider, useSocket }
